// src/Firebase/storageBlog.js

import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";

// Initialize Storage (Ensure this matches your firebaseConfig.js)
const storage = getStorage();

/**
 * Uploads a file to Firebase Storage.
 * @param {File} file - The file to upload.
 * @param {string} folder - The folder in Firebase Storage where the file will be stored.
 * @param {function} onProgress - Callback to handle upload progress.
 * @returns {Promise<{ storagePath: string, downloadURL: string }>}
 */
export const uploadFile = (file, folder, onProgress) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error("No file provided for upload."));
      return;
    }

    const storagePath = `${folder}/${Date.now()}_${file.name}`;
    const fileRef = ref(storage, storagePath);
    const uploadTask = uploadBytesResumable(fileRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (onProgress) {
          onProgress(progress);
        }
        console.log(`Upload is ${progress}% done`);
      },
      (error) => {
        console.error("Upload failed:", error);
        reject(error);
      },
      async () => {
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve({ storagePath, downloadURL });
        } catch (error) {
          console.error("Failed to get download URL:", error);
          reject(error);
        }
      }
    );
  });
};

/**
 * Deletes a file from Firebase Storage.
 * @param {string} storagePath - The storage path of the file to delete.
 * @returns {Promise<void>}
 */
export const deleteFile = (storagePath) => {
  return new Promise((resolve, reject) => {
    if (!storagePath) {
      reject(new Error("No storage path provided for deletion."));
      return;
    }

    const fileRef = ref(storage, storagePath);
    deleteObject(fileRef)
      .then(() => {
        console.log("File deleted successfully.");
        resolve();
      })
      .catch((error) => {
        console.error("Error deleting file:", error);
        reject(error);
      });
  });
};
